/**
 * @component {"type":"Audio","version":"1.1"}
 * @component {"type":"Video","version":"1.1"}
 */

define('component-media',['knockout', 'helpers', 'training'], function(ko, helpers, Training) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            media;

        self.videoVisible = ko.observable(false);
        self.videoTitle = ko.observable('');

        self.audioInteracted = ko.observable('true');
        self.videoInteracted = ko.observable('true');

        /**
         * Changes audio track of audio element on page
         * @param {Number} index - index of track starting from 0
         * @param {Number} seekTime - time to seek in full seconds
         * @param {Boolean} pauseAtStart - pause playing after changing track
         */
        self.changeAudioTrack = function (index, seekTime, pauseAtStart) {
            var audioEl = document.querySelector('audio');
            try {
                audioEl.setAttribute('src', trainingVM.parseMediaURL(trainingVM.getComponentsByKind('Audio')[0].content.audio[index].content.source));
                audioEl.currentTime = seekTime || 0;
                if (!pauseAtStart) audioEl.play();
            } catch (e) {
                if (dataContext.debugMode) {
                    console.dir(e);
                }
            }
        };

        /**
         * Changes video track of video element on page
         * @param {Number} index - index of track starting from 0
         * @param {Number} seekTime - time to seek in full seconds
         * @param {Boolean} pauseAtStart - pause playing after changing track
         */
        self.changeVideoTrack = function (index, seekTime, pauseAtStart) {
            var videoEl = document.querySelector('video');
            try {
                videoEl.setAttribute('src', trainingVM.parseMediaURL(trainingVM.getComponentsByKind('Video')[0].content.video[index].content.source[0].content.source));
                videoEl.currentTime = seekTime || 0;
                if (!pauseAtStart) document.querySelector('video').play();
            } catch (e) {
                if (dataContext.debugMode) {
                    console.dir(e);
                }
            }
        };

        ko.bindingHandlers.initVideo = {
            update  : function() {
                var component = helpers.component.getContent(entityVM.componentsJSON(), 'Video'),
                    arr = helpers.component.parseProp(component, 'video', 'VideoItem');

                self.videoVisible(false);

                if (media) {
                    media.dispose('video-player', dataContext.debugMode);
                }

                if (!arr.length) {
                    return;
                }

                var interacted = !component.interaction;

                self.videoInteracted(interacted.toString());

                require(['media'], function(Media) {
                    var ID = 'video-player' + '_' + new Date().getTime(),
                        video, options,
                        src = helpers.component.parseProp(arr[0], 'source', 'VideoSource');

                    media = media || new Media({
                        training: new Training()
                    });

                    video = media.parse(arr[0], 'video', src);
                    options = media.options('video', video, dataContext.mediaOrder);

                    self.videoTitle(video.name);

                    video.HTML = '<video id="' + ID + '" class="video-js video-skin" ' + video.poster + ' preload="' + video.preload + '" width="auto" height="auto" ' + video.quality + ' >';

                    if (video.captions) {
                        video.HTML += '<track kind="subtitles" src="' + video.captions + '" label="subtitles-on" ' + video.captionsOn + '></track>';
                    }

                    video.HTML += ' </video>';

                    var box = document.getElementById('video-box');

                    if (!box) {
                        return;
                    }

                    box.innerHTML += video.HTML;

                    if (interacted) {
                        media.initVideo(ID, video, options, box, dataContext.debugMode);
                    } else {
                        media.initVideo(ID, video, options, box, dataContext.debugMode, trainingVM.updateVisited);
                    }

                    self.videoVisible(true);

                });
            }
        }

        ko.bindingHandlers.initAudio = {
            update  : function() {
                var component = helpers.component.getContent(entityVM.componentsJSON(), 'Audio'),
                    arr = helpers.component.parseProp(component, 'audio', 'AudioItem');

                if (media) {
                    media.dispose('audio-player', dataContext.debugMode);
                }

                if (!arr.length) {
                    return;
                }

                var interacted = !component.interaction;

                self.audioInteracted(interacted.toString());

                require(['media'], function(Media) {
                    var ID = 'audio-player' + '_' + new Date().getTime(),
                        audio, options;

                    media = media || new Media({
                        training: new Training()
                    });

                    audio = media.parse(arr[0], 'audio');
                    options = media.options('audio', audio, dataContext.mediaOrder);

                    audio.HTML = '<audio id="' + ID + '" src="' + audio.source + '" class="audio-js audio-skin vh" controls preload="' + audio.preload + '" width="auto" height="auto" >';

                    if (audio.captions) {
                        audio.HTML += '<track kind="subtitles" src="' + audio.captions + '" label="subtitles-on" ' + audio.captionsOn + '></track>';
                    }

                    audio.HTML += ' </audio>';

                    var box = document.getElementById('audio-box');

                    if (!box) {
                        return;
                    }

                    box.innerHTML += audio.HTML;

                    if (interacted) {
                        media.initAudio(ID, audio, options, dataContext.debugMode);
                    } else {
                        media.initAudio(ID, audio, options, dataContext.debugMode, trainingVM.updateVisited);
                    }

                });

            }
        };

    };

});

